import { BsShop } from "react-icons/bs";
import { MdPendingActions, MdOutlineManageAccounts } from "react-icons/md";
import { FaCogs, FaStopwatch, FaUserLock } from "react-icons/fa";
import { AiFillAppstore, AiOutlineUser } from "react-icons/ai";
import { BiCalendarCheck, BiCalendarX } from "react-icons/bi";
import { IoPaperPlane } from "react-icons/io5";
import { LetterTextIcon } from "lucide-react";

export const adminLinks = [
  {
    route: `/app/dashboard`,
    name: "Dashboard",
    Icon: AiFillAppstore,
    allowed: ["Admin"],
  },

  {
    route: `/app/profile`,
    name: "Profile",
    Icon: AiOutlineUser,
    allowed: ["User", "Admin"],
  },
  {
    route: `/app/loan/application`,
    name: "Loan Application",
    Icon: IoPaperPlane,
    allowed: ["User", "Admin"],
  },
  {
    route: `/app/loan/all`,
    name: "All Loan Request",
    Icon: MdPendingActions,
    allowed: ["User", "Admin"],
  },
  {
    route: `/app/loan/pending`,
    name: "Pending Loans",
    Icon: MdPendingActions,
    allowed: ["User", "Admin"],
  },
  {
    route: `/app/loan/approved`,
    name: "Approved Loans",
    Icon: BiCalendarCheck,
    allowed: ["User", "Admin"],
  },
  {
    route: `/app/loan/declined`,
    name: "Declined Loans",
    Icon: BiCalendarX,
    allowed: ["User", "Admin"],
  },
  // {
  //   route: `/app/offer`,
  //   name: "Offer Letter",
  //   Icon: LetterTextIcon,
  //   allowed: ["User", "Admin"],
  // },
];

export const csuLinks = [
  {
    route: `/csu/dashboard`,
    name: "Dashboard",
    Icon: BsShop,
    allowed: ["Admin"],
  },

  {
    route: `#`,
    name: "Account Opening Requests",
    Icon: MdOutlineManageAccounts,
    allowed: ["User", "Admin"],
    children: [
      {
        route: `/csu/account/individual`,
        name: "Individual Account",
        Icon: FaUserLock,
        allowed: ["User", "Admin"],
      },
      {
        route: `/csu/account/corporate`,
        name: "Corporate Account",
        Icon: FaCogs,
        allowed: ["User", "Admin"],
      },
    ],
  },
  {
    route: `/csu/account/upgrade`,
    name: "Account Upgrade Requests",
    Icon: FaStopwatch,
    allowed: ["User", "Admin"],
  },
  {
    route: `/csu/returned`,
    name: "Returned for Correction",
    Icon: MdOutlineManageAccounts,
    allowed: ["User", "Admin"],
  },
];

export const hopLinks = [
  {
    route: `/hop/dashboard`,
    name: "Dashboard",
    Icon: BsShop,
    allowed: ["Admin"],
  },

  {
    route: `#`,
    name: "Account Opening Requests",
    Icon: MdOutlineManageAccounts,
    allowed: ["User", "Admin"],
    children: [
      {
        route: `/hop/account/individual`,
        name: "Individual Account",
        Icon: FaUserLock,
        allowed: ["User", "Admin"],
      },
      {
        route: `/hop/account/corporate`,
        name: "Corporate Account",
        Icon: FaCogs,
        allowed: ["User", "Admin"],
      },
    ],
  },
  {
    route: `/hop/account/upgrade`,
    name: "Account Upgrade Requests",
    Icon: FaStopwatch,
    allowed: ["User", "Admin"],
  },
];
